/**
 * コメント候補テンプレート一覧を取得する。
 * 管理シートや入力ドロップダウンで利用するため、displayOrder 昇順で返す。
 */

import { asc } from 'drizzle-orm'
import { commentCandidateSchema } from '../../querySchema'
import { commentCandidateTable } from '../../schema'
import type { DatabaseWithTransaction } from '../../types'

/**
 * コメント候補テンプレート一覧を取得する。
 * @param params DB 接続を受け取る。
 * @returns コメント候補テンプレート一覧を返す。
 */
export const selectCommentCandidates = async ({
  database: { database },
}: {
  readonly database: DatabaseWithTransaction
}) => {
  const rows = await database
    .select()
    .from(commentCandidateTable)
    .orderBy(
      asc(commentCandidateTable.displayOrder),
      asc(commentCandidateTable.id),
    )

  return rows.map((row) => commentCandidateSchema.parse(row))
}
